let items

const RecipeCalc = {
  init: function() {
    const wrapper = document.querySelector('[data-recipe-ingredients]')
    items = wrapper?.querySelectorAll('.recipe__item')
    if (!items) return

    document.addEventListener('click', e => this.handleServeSize(e.target))
    this.renderItems()
  },

  handleServeSize: function(clicked) {
    if (clicked.matches('.serves-control.active') || !clicked.matches('.serves-control')) return

    const active = document.querySelector('.serves-control.active')
    active.classList.remove('active')
    clicked.classList.add('active')

    this.calculate(clicked.dataset.serves, clicked.dataset.default)
  },

  calculate: function(serves, base) {
    items.forEach(item => {
      const q = item.querySelector('.item__quantity')
      const defaultQuantity = q.dataset.defaultQuantity
      q.dataset.quantity = defaultQuantity / base * serves
    })

    this.renderItems()
  },

  renderItems: function() {
    items.forEach(item => {
      const q = item.querySelector('.item__quantity'),
            u = item.querySelector('.item__units'),
            n = item.querySelector('.item__name')

      q.innerHTML = this.toFraction(q.dataset.quantity)

      if (u) {
        let units = u.dataset.singular
        if (q.dataset.quantity >= 2 && u.dataset.plural) units = u.dataset.plural
        u.innerHTML = units
      }

      if (n) {
        let name = n.dataset.singular
        if (q.dataset.quantity >= 2 && n.dataset.plural) name = n.dataset.plural
        if (n.dataset.link) name = `<a href="${n.dataset.link}">${name}</a>`
        n.innerHTML = name
      }
    })
  },

  toFraction: function(x, tolerance) {
    if (x == 0) return [0, 1];
    if (x < 0) x = -x;
    if (!tolerance) tolerance = 0.0001;
    var num = 1, den = 1;
    function iterate() {
        var R = num/den;
        if (Math.abs((R-x)/x) < tolerance) return;

        if (R < x) num++;
        else den++;
        iterate();
    }
    iterate();
    let integer = 0
    if (num >= den) {
      integer = Math.floor(num / den)
      num = num % den
    }
    const result = `${integer ? integer + ' ' : ''}${num ? '&frac' + num + den + ';' : ''}`
    return result;
  }
}

export default RecipeCalc
